export const _initialState = {
  stackDimensions: {
    height: 0,
    width: 0,
    depth: 0,
  },
  // 303005621: {
  //   height: 25,
  //   width: 25,
  //   depth: 25,
  // },
  // 303005652: {
  //   height: 20,
  //   width: 20,
  //   depth: 20,
  // },
  // 303005752: {
  //   height: 10,
  //   width: 10,
  //   depth: 10,
  // },
  // 311009007: {
  //   height: 5,
  //   width: 10,
  //   depth: 22,
  // },
  // 315846999: {
  //   height: 15,
  //   width: 15,
  //   depth: 15,
  // },
};
